import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps";
import ReactTypingEffect from "react-typing-effect";
import data from "../../card-projects.json";
import { format } from "indian-number-format";
import CountUp from "react-countup";

import { db } from "../../firebase/config";
import { doc, getDoc, setDoc, increment } from "firebase/firestore";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );
  const paperWidth = 170;
  const paperHeight = 140;

  const innerClasses = classNames(
    "hero-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );
  const [viewCounter, setViewCounter] = useState("");
  const [accountCounter, setAccountCounter] = useState("");
  const [amountCounter, setAmountCounter] = useState("");
  const [randomFloatMetrics, setRandomFloatMetrics] = useState("");

  useEffect(() => {
    async function action() {
      const docRef = doc(db, "websiteDynamicData", "counter");
      const docSnap = await getDoc(docRef);
      await setViewCounter(docSnap.data()["viewCounter"]);

      // const accDocRef = doc(db, "websiteDynamicData", "counter");
      //const accDocSnap = await getDoc(docRef);

      await setAmountCounter(docSnap.data()["amountCounter"]);

      await setAccountCounter(docSnap.data()["accountCounter"]);

      setDoc(
        docRef,
        {
          viewCounter: increment(1),
        },
        {
          merge: true,
        }
      );
    }
    action();
  }, []);

  useEffect(() => {
    let max = 9.09;
    let min = 18.18;
    setInterval(() => {
      const rand = (Math.random() * (max - min) + min).toFixed(2);
      setRandomFloatMetrics(rand);
    }, 1500);

    setInterval(() => {
      const rand = (Math.random() * (max - min) + min).toFixed(2);
      setRandomFloatMetrics(rand);
    }, 2960);
  }, []);

  return (
    <React.StrictMode>
      <section {...props} className={outerClasses}>
        <div className="container-sm">
          <div className={innerClasses}>
            <div className="hero-content">
              {/* <h1
                className="mt-0 mb-16 reveal-from-bottom"
                data-reveal-delay="200"
              >
                Crowdfunding platform for <br />{" "}
                <span className="text-color-primary">real estate</span>
              </h1>*/}

              <div className="container-xs">
                <p
                  className="m-0 mb-32 reveal-from-bottom"
                  data-reveal-delay="400"
                >
                  Be a part of something{" "}
                  <span className="text-color-primary">NEW</span> and{" "}
                  <span className="text-color-primary">BIG</span>
                </p>

                <ReactTypingEffect
                  speed="120ms"
                  eraseSpeed="80ms"
                  text={[
                    "Build a better trust",
                    "It’s all about the people",
                    "Are you ready to start the next big thing with us?",
                    "Take a chance on us...",
                    "...and we'll make sure you never taking that chance",
                    "Better returns than other invesment options",
                    "Real estate is consistent and consistent is good",
                  ]}
                />

                <div className="container metrics">
                  <Grid sx={{ flexGrow: 1 }} container spacing={2}>
                    <Grid item xs={12}>
                      <Grid container justifyContent="center" spacing={3}>
                        <Grid key={1} item className="metrics-grid-item">
                          <Paper
                            className="metrics-paper"
                            elevation={24}
                            sx={{
                              height: paperHeight,
                              width: paperWidth,
                              color: "#fff",
                              borderradius: 10,
                              backgroundColor: (theme) =>
                                theme.palette.mode === "dark"
                                  ? "#1A2027"
                                  : "#1A2027",
                            }}
                          >
                            <CountUp
                              className="counter"
                              end={1000}
                              prefix="₹ "
                              duration={1}
                              suffix=" <br/>"
                            />
                            Minimum investment
                          </Paper>
                        </Grid>

                        <Grid key={3} item>
                          <Paper
                            className="metrics-paper"
                            elevation={24}
                            sx={{
                              height: paperHeight,
                              width: paperWidth,
                              color: "#fff",
                              backgroundColor: (theme) =>
                                theme.palette.mode === "dark"
                                  ? "#1A2027"
                                  : "#1A2027",
                            }}
                          >
                            <CountUp
                              className="counter"
                              end={accountCounter}
                              duration={2}
                              suffix="+ <br/>"
                            />
                            Investors
                          </Paper>
                        </Grid>

                        <Grid key={6} item>
                          <Paper
                            className="metrics-paper"
                            elevation={24}
                            sx={{
                              height: paperHeight,
                              width: paperWidth,
                              color: "#fff",
                              backgroundColor: (theme) =>
                                theme.palette.mode === "dark"
                                  ? "#1A2027"
                                  : "#1A2027",
                            }}
                          >
                            <CountUp
                              className="counter"
                              end={amountCounter}
                              duration={2}
                              suffix="Cr <br/>"
                              prefix="₹ "
                            />
                            Investment Value
                          </Paper>
                        </Grid>

                        <Grid key={4} item>
                          <Paper
                            className="metrics-paper"
                            elevation={24}
                            sx={{
                              height: paperHeight,
                              width: paperWidth,
                              color: "#fff",
                              backgroundColor: (theme) =>
                                theme.palette.mode === "dark"
                                  ? "#1A2027"
                                  : "#1A2027",
                            }}
                          >
                            <CountUp
                              className="counter metrics-rental-returns randomFloatMetrics"
                              end={10}
                              duration={1.5}
                              suffix="%<superscript><small>*</small></superscript> <strong><b>↑</b></strong> <br/>"
                            />
                            Rental returns and more
                          </Paper>
                        </Grid>
                        <Grid key={5} item>
                          <Paper
                            className="metrics-paper"
                            elevation={24}
                            sx={{
                              height: paperHeight,
                              width: paperWidth,
                              color: "#fff",
                              backgroundColor: (theme) =>
                                theme.palette.mode === "dark"
                                  ? "#1A2027"
                                  : "#1A2027",
                            }}
                          >
                            <span className="counter randomFloatMetrics">
                              {randomFloatMetrics}%+
                            </span>
                            <br />
                            High returns
                          </Paper>
                        </Grid>
                        <Grid key={2} item>
                          <Paper
                            className="metrics-paper"
                            elevation={24}
                            sx={{
                              height: paperHeight,
                              width: paperWidth,
                              color: "#fff",
                              backgroundColor: (theme) =>
                                theme.palette.mode === "dark"
                                  ? "#1A2027"
                                  : "#1A2027",
                            }}
                          >
                            <CountUp
                              className="counter"
                              end={viewCounter}
                              duration={2}
                              suffix=" <br/>"
                            />
                            Page Visits
                          </Paper>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>

            <div
              className="hero-figure reveal-from-bottom illustration-element-01"
              data-reveal-value="20px"
              data-reveal-delay="800"
            >
              <div className="container noselect">
                <h2>Some of our work...</h2>
                <ul className="cards scrollable-ul">
                  {data.map((data, index) => {
                    return (
                      <li className="card " key={index}>
                        <div className="float-container ">
                          <div className="flex-container flex-container-custom float-child float-child-1">
                            <div className="card-font-small card-left-top card-content-color-white col-sm-6 flex-child-1 flex-child">
                              <div className="card-font-medium card-left-top">
                                <i className="fa fa-map-marker"></i>
                                {" " + data.projectLocation + "  "}
                                <br />
                                <span className="card-font-small">
                                  {(data.projectStatus
                                    ? "(Ongoing since " + data.projectStartYear
                                    : "(Completed in " +
                                      data.projectRevaluationYear) + ")"}
                                </span>
                              </div>

                              <div className="card-font-small card-left-top card-content-color-white">
                                {"Tenure: " +
                                  (data.projectRevaluationYear -
                                    data.projectStartYear)}{" "}
                                years
                              </div>
                              <div className="card-font-small card-left-top card-content-color-white">
                                <i className="fa fa-inr card-title"></i>
                                {" " + format(data.projectCurrentValue)}
                                <span className="card-font-small-extra">
                                  {data.projectStatus
                                    ? "(as per current year's valuation)"
                                    : ""}
                                </span>
                              </div>
                            </div>
                            <div className="card-link-wrapper card-right-top col-sm-6 flex-child flex-child-2">
                              <span className="card-link-2">
                                ~
                                {Math.round(
                                  (((data.projectCurrentValue /
                                    data.projectValue) **
                                    (1 /
                                      (data.projectRevaluationYear -
                                        data.projectStartYear)) -
                                    1) *
                                    100 +
                                    Number.EPSILON) *
                                    100
                                ) /
                                  100 +
                                  "% p.a."}
                              </span>
                            </div>
                          </div>
                          <br />
                          <div className="card-link-wrapper card-font-small card-description float-child float-child-2">
                            <p href="" className="card-link">
                              {data.projectDescription +
                                " " +
                                Math.round(
                                  (((data.projectCurrentValue /
                                    data.projectValue) **
                                    (1 /
                                      (data.projectRevaluationYear -
                                        data.projectStartYear)) -
                                    1) *
                                    100 +
                                    Number.EPSILON) *
                                    100
                                ) /
                                  100 +
                                "% (Annualized Returns)"}
                            </p>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <footer className="page-footer"></footer>
            </div>
          </div>
        </div>
      </section>
    </React.StrictMode>
  );
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
